import { differenceInHours } from 'date-fns';

import { SearchBankTransfersQuery } from './graphql/searchBankTransfers.gql';

type SomeDuplicateTransferProps = {
  bankTransferEdges: SearchBankTransfersQuery['viewer']['company']['transactionsSearch']['edges'];
  bankTransferRecipientId: string;
  amount: number;
};

export const someDuplicateTransfer = ({
  amount,
  bankTransferEdges,
  bankTransferRecipientId,
}: SomeDuplicateTransferProps) => {
  if (!bankTransferEdges) {
    return false;
  }

  return bankTransferEdges.some((edge) => {
    const sameBankRecipientId =
      edge?.node.bankTransfer?.bankTransferRecipientId ===
      bankTransferRecipientId;

    const createdInTheLastHour =
      differenceInHours(new Date(), edge?.node.createdAt) === 0;

    const sameAmount = edge?.node.value === amount;

    return sameBankRecipientId && createdInTheLastHour && sameAmount;
  });
};
